import React, { Component } from 'react'
import './addAdmin.scss'
import {
  NavBar,
  Icon,
  InputItem,
  List,
  Button,
  WhiteSpace,
  WingBlank,
  Picker,
  Toast,
  Accordion,
  Checkbox,
  Badge,
} from 'antd-mobile'
import { createForm } from 'rc-form'
import { connect } from 'dva'
import cookie from 'js-cookie'
const Item = List.Item
const CheckboxItem = Checkbox.CheckboxItem
const loginFlagDatas = [
  {
    label: '不允许',
    value: 0,
  },
  {
    label: '允许',
    value: 1,
  },
]
@connect(({ enterpriseadmin, app }) => ({ enterpriseadmin, app }))
export class AddAdmin extends Component {
  state = {
    funcGidArr: [],
    showValidateMonths: true,
    totalPrice: '0',
    checkedFuncGidArr: [],
  }
  componentDidMount() {
    // 查询功能组
    this.props.dispatch({
        type: "enterpriseadmin/getAdminFindLoginName",
        payload: { loginName: this.props.match.params.loginName },
    });
  }
  validateAccount = (rule, value, callback) => {
    if (value) {
      if (value.length >= 2) {
        if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,12}$/.test(value)) {
          callback(new Error('格式不正确，只能包含数字中文字母和下划线'))
        } else {
          callback()
        }
      } else {
        callback(new Error('账号长度不能少于2'))
      }
    } else {
      callback('请输入账号')
    }
  }
  validateName = (rule, value, callback) => {
    if (value) {
      if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,12}$/.test(value)) {
        callback(new Error('格式不正确，只能包含数字中文字母和下划线'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
  validatePassword = (rule, value, callback) => {
    if (value) {
      if (value.length < 3) {
        callback(new Error('密码不能少于3位'))
      } else if (!/^[a-zA-Z0-9]{3,20}$/.test(value)) {
        callback(new Error('密码只支持不大于20的数字和大小写字母'))
      } else {
        callback()
      }
    } else {
      callback(new Error('密码不能为空'))
    }
  }
  validateConPassword = (rule, value, callback) => {
    const { password } = this.props.form.getFieldsValue()
    if (value) {
      if (value != password) {
        callback(new Error('密码不一致，请确认密码'))
      } else {
        callback()
      }
    } else {
      callback(new Error('请确认密码'))
    }
  }
  validateMonths = (rule, value, callback) => {
    if (value) {
      callback()
    } else {
      if (!this.state.showValidateMonths) {
        callback()
      } else {
        callback(new Error('请输入购买月数'))
      }
    }
  }
  validateFgidList = (rule, value, callback) => {
    if (value) {
      if (value.length < 1) {
        callback(new Error('请选择功能组'))
      } else {
        callback()
      }
    } else {
      callback(new Error('请选择功能组'))
    }
  }
  render() {
    const { getFieldProps, getFieldError } = this.props.form
    const { dispatch, enterpriseadmin, app, form } = this.props
    const { validateFields, getFieldsValue, setFieldsValue } = form
    const { loginMsgUser } = enterpriseadmin
    const { funcGroupList } = app
    const { showValidateMonths, totalPrice } = this.state
    const {
      name,
      loginName,
      password,
      days,
      website,
      email,
      mobile,
      phone,
      qq,
      remarks,
      loginFlag,
    } = loginMsgUser
    const { type } = this.props.match.params
    const userType = cookie.get('userType')
    const userMsg =
      sessionStorage.getItem('loginMsg') &&
      JSON.parse(sessionStorage.getItem('loginMsg'))
    const submit = () => {
			
      validateFields({ force: true }, (error, value) => {
        const { loginFlag } = value
        if (!error) {
          Toast.loading('加载中...', 0)
          if (type == 'edit') {
            dispatch({
              type: 'enterpriseadmin/adminUpdateManager',
              payload: {
                ...value,
                loginFlag: loginFlag[0],
                id: this.props.match.params.id,
                months: showValidateMonths ? value.months : 120,
              },
            })
          } else {
            dispatch({
              type: 'enterpriseadmin/subUserAdminAdd',
              payload: {
                ...getFieldsValue(),
                loginFlag: loginFlag[0],
                id: this.props.match.params.id,
                months: showValidateMonths ? value.months : 120,
              },
            }).then(res => {
							if (res.status == 200) {
								Toast.success('添加成功')
							}
							window.location.pathname ='/enterprise/admin/enterpriseAdminList'
						})
						
          }
        }
      })
    }
    const onChange = (e, id, item) => {
      let arr = this.state.funcGidArr
      if (e.target.checked) {
        arr.push(item)
      } else {
        arr.splice(arr.map((item) => item.id).indexOf(id), 1)
      }

      let isDiscount = arr.map((item) => item.type).indexOf(1) >= 0
      this.setState({
        showValidateMonths: !isDiscount,
      })

      this.setState(
        {
          checkedFuncGidArr: arr,
        },
        () => {
          sumTotalPrice()
        }
      )
      setFieldsValue({
        fgidList: arr.map((item) => item.id),
      })
    }
    const sumTotalPrice = () => {
      let months = form.getFieldValue('months')
      months = months ? months : 0
      let sumTotalPrice = 0
      this.state.checkedFuncGidArr.filter((item) => {
        sumTotalPrice += item.adminAmount
      })
      sumTotalPrice *= months
      this.setState({
        totalPrice: sumTotalPrice.toString(),
      })
    }
    return (
      <div className='addAdmin'>
        <div className='header-sticky'>
          <NavBar
            icon={<Icon type='left' />}
            onLeftClick={() => this.props.history.goBack()}
          >
            {type == 'edit' ? '修改' : '添加'}
            企业管理员
          </NavBar>
        </div>
        <div className='sub-container'>
          <form>
            <List
              renderFooter={() =>
                getFieldError('name') ||
                getFieldError('loginName') ||
                getFieldError('password') ||
                getFieldError('conPassword') ||
                getFieldError('fgidList') ||
                getFieldError('months')
              }
            >
              <WhiteSpace size='lg' />
              <InputItem
                {...getFieldProps('name', {
                  rules: [{ validator: this.validateName }],
                  initialValue: name,
                })}
                clear
                maxLength='12'
              >
                名字
              </InputItem>
              <InputItem
                {...getFieldProps('loginName', {
                  rules: [{ validator: this.validateAccount }],
                  initialValue: loginName,
                })}
                error={!!getFieldError('loginName')}
                clear
                placeholder='支持中文、英文、数字或下划线'
                maxLength='11'
              >
                登录账号
                <i className='red-star'>*</i>
              </InputItem>
              <InputItem
                {...getFieldProps('password', {
                  rules: [
                    {
                      validator: this.validatePassword,
                    },
                  ],
                  initialValue: password,
                })}
                error={!!getFieldError('password')}
                clear
                type={type == 'edit' ? 'text' : 'password'}
                maxLength='20'
              >
                密码
                <i className='red-star'>*</i>
              </InputItem>
              <InputItem
                {...getFieldProps('conPassword', {
                  rules: [{ validator: this.validateConPassword }],
                  initialValue: password,
                })}
                error={!!getFieldError('conPassword')}
                clear
                type={type == 'edit' ? 'text' : 'password'}
                maxLength='18'
              >
                确认密码
                <i className='red-star'>*</i>
              </InputItem>
              {userMsg && userMsg.userType == 0 ? (
                <InputItem
                  {...getFieldProps('days', {
                    initialValue: days,
                  })}
                  type='number'
                  clear
                  maxLength='11'
                >
                  定位保存时间
                </InputItem>
              ) : (
                ''
              )}

              <InputItem
                {...getFieldProps('email', {
                  initialValue: email,
                })}
                clear
              >
                邮箱
              </InputItem>
              <InputItem
                {...getFieldProps('mobile', {
                  initialValue: mobile,
                })}
                type='number'
                clear
              >
                手机
              </InputItem>
              <InputItem
                {...getFieldProps('phone', {
                  initialValue: phone,
                })}
                type='number'
                clear
                maxLength='11'
              >
                座机
              </InputItem>
              <InputItem
                {...getFieldProps('qq', {
                  initialValue: qq,
                })}
                clear
                type='number'
              >
                QQ
              </InputItem>
              <InputItem
                {...getFieldProps('remarks', {
                  initialValue: remarks,
                })}
                clear
              >
                备注
              </InputItem>
              <Picker
                {...getFieldProps('loginFlag', {
                  initialValue: [loginFlag ? Number(loginFlag) : 1],
                })}
                data={loginFlagDatas}
                cols={1}
                key='1'
              >
                <Item key='1' arrow='horizontal'>
                  是否允许登录
                </Item>
              </Picker>
              {type != 'edit' && userMsg ? (
                <div>
                  <Accordion defaultActiveKey='0'>
                    <Accordion.Panel
                      {...getFieldProps('fgidList', {
                        rules: [
                          {
                            validator: this.validateFgidList,
                          },
                        ],
                      })}
                      header={
                        <div>
                          <span className='red-star'>*</span>
                          功能组：
                        </div>
                      }
                    >
                      <List className='my-list'>
                        {funcGroupList.map((item) => (
                          <CheckboxItem
                            key={item.id}
                            onChange={(e) => onChange(e, item.id, item)}
                          >
                            {item.name}
                          </CheckboxItem>
                        ))}
                      </List>
                    </Accordion.Panel>
                  </Accordion>
                  {/* {showValidateMonths ? (
                    <InputItem
                      {...getFieldProps('months', {
                        rules: [
                          {
                            validator: this.validateMonths,
                          },
                        ],
                      })}
                      onBlur={sumTotalPrice}
                      type='number'
                      clear
                    >
                      <i className='red-star'>*</i>
                      购买月数：
                    </InputItem>
                  ) : (
                    <div
                      {...getFieldProps('months', {
                        rules: [
                          {
                            validator: this.validateMonths,
                          },
                        ],
                      })}
                    ></div>
                  )} */}
                  {/* <List.Item>
                    虚拟币总数：
                    <Badge
                      text={totalPrice}
                      style={{
                        padding: '0 3px',
                        backgroundColor: '#fff',
                        color: '#108ee9',
                        borderRadius: 2,
                        border: '1px solid #108ee9',
                      }}
                    />
                  </List.Item> */}
                </div>
              ) : (
                ''
              )}
            </List>
            <WhiteSpace size='lg' />
            <WingBlank>
              <Button onClick={submit} type='primary'>
                {type == 'edit' ? '修改' : '添加'}
              </Button>
              <WhiteSpace size='lg' />
              <Button onClick={() => this.props.history.goBack()}>返回</Button>
            </WingBlank>
            <WhiteSpace size='lg' />
          </form>
        </div>
      </div>
    )
  }
}
export default createForm()(AddAdmin)
